import React, { useEffect } from 'react'
import {useDispatch, useSelector} from "react-redux"
import {Navigate, useLocation} from "react-router-dom"
import { fetchUserProfile } from '../redux/Slice/AuthSlice';

const PrivateRoute = ({children, module, action}) => {

    const dispatch = useDispatch();

    const { profile } = useSelector((state) => state.auth);

    const verifyRoute = profile?.permissions.find(va => va.moduleName === module ||  va.moduleName === "*")?.actions;

    let location = useLocation();

    useEffect(()=>{
        // dispatch(fetchUserProfile())
      }, [dispatch])

    if(verifyRoute && !(verifyRoute?.includes(action) || verifyRoute?.includes("*"))) {
        return <Navigate to="unauthorized" state={{ from: location}} replace />
    }
    
 return children

};

export default PrivateRoute;